<!--  -->
<template>
 <div class="myplan-banner" :style="{background:'url('+homeBanner+') no-repeat center'}">
    <div  class="animated animatedFadeIn">
      <div class="myplan-banner-main">
         <div class="myplan-banner-right">
            <MyplanCircle ref="childData"></MyplanCircle>
        </div>
        <div class="myplan-banner-left">
          <h2>总申请规划完成度</h2>
          <h3>离你的梦校越来越近啦！</h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyplanCircle from './myplan-circle'
import homeBanner from '@/assets/images/myplan/homebanner.png'
export default {
  name: '',
  components: {
    MyplanCircle
  },
  data () {
    return {
      homeBanner
    }
  },
  computed: {},
  mounted () {},
  methods: {
    getChildData () {
      this.$refs.childData.planQueryInfoPhasesList()
    }
  }
}
</script>
<style lang='less' scoped>
.myplan-banner {
  height:320px;
  background-color:#F0F0F0;
  margin-bottom:40px;
  .myplan-banner-main{
    width:820px;
    height:320px;
    margin:0 auto;
    display: flex;
    align-items: center;
    .myplan-banner-left{
     color:#ffffff;
     h2{
       font-size:32px;
       font-weight: normal;
     }
     h3{
       font-size:20px;
       padding-top:24px;
       font-weight: normal;
     }
    }
    .myplan-banner-right{
      margin-right:56px;
    }
  }
}
</style>
